import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import berita from './views/berita.vue'
import isi_berita from './views/isi_berita.vue'

import tentang from './views/profil/tentang.vue'
import visi from './views/profil/visi.vue'
import misi from './views/profil/misi.vue'
import data_pegawai from './views/profil/data_pegawai.vue'
import struktur_organisasi from './views/profil/struktur_organisasi.vue'

import kegiatan from './views/kegiatan.vue'
import isi_kegiatan from './views/isi_kegiatan.vue'

import profil_kependudukan from './views/profil_kependudukan.vue'
import data_agregat_kependudukan from './views/data_agregat_kependudukan.vue'
import pengumuman from './views/pengumuman.vue'

import foto from './views/galeri/foto.vue'
import video from './views/galeri/video.vue'

import kependudukan from './views/layanan/kependudukan.vue'
import pencatatan_sipil from './views/layanan/pencatatan_sipil.vue'


import formulir_kependudukan from './views/download/formulir_kependudukan.vue'
import formulir_pencatatan_sipil from './views/download/formulir_pencatatan_sipil.vue'

import data_chart_kependudukan from './views/data/data_chart_kependudukan.vue'
import rencana_publish from './views/data/rencana_publish.vue'




Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/berita',
      name: 'berita',
      component: berita
    },
    {
      path: '/isi_berita/:id',
      name: 'isi_berita',
      component: isi_berita
    },


    {
      path: '/tentang',
      name: 'tentang',
      component: tentang
    },
    {
      path: '/visi',
      name: 'visi',
      component: visi
    },
    {
      path: '/misi',
      name: 'misi',
      component: misi
    },
    {
      path: '/data_pegawai',
      name: 'data_pegawai',
      component: data_pegawai
    },
    {
      path: '/struktur_organisasi',
      name: 'struktur_organisasi',
      component: struktur_organisasi
    },


    {
      path: '/kegiatan',
      name: 'kegiatan',
      component: kegiatan
    },
    {
      path: '/isi_kegiatan/:id',
      name: 'isi_kegiatan',
      component: isi_kegiatan
    },

    {
      path: '/profil_kependudukan',
      name: 'profil_kependudukan',
      component: profil_kependudukan
    },
    {
      path: '/data_agregat_kependudukan',
      name: 'data_agregat_kependudukan',
      component: data_agregat_kependudukan
    },
    {
      path: '/data_chart_kependudukan',
      name: 'data_chart_kependudukan',
      component: data_chart_kependudukan
    },
    {
      path: '/rencana_publish',
      name: 'rencana_publish',
      component: rencana_publish
    },
    {
      path: '/pengumuman',
      name: 'pengumuman',
      component: pengumuman
    },

    {
      path: '/foto',
      name: 'foto',
      component: foto
    },
    {
      path: '/video',
      name: 'video',
      component: video
    },
    {
      path: '/kependudukan',
      name: 'kependudukan',
      component: kependudukan
    },
    {
      path: '/pencatatan_sipil',
      name: 'pencatatan_sipil',
      component: pencatatan_sipil
    },

    {
      path: '/formulir_kependudukan',
      name: 'formulir_kependudukan',
      component: formulir_kependudukan
    },
    {
      path: '/formulir_pencatatan_sipil',
      name: 'formulir_pencatatan_sipil',
      component: formulir_pencatatan_sipil
    },
  ]
})
